module.exports = ".hideElement {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/usuarios/usuarios.component.scss
// module id = ./src/app/components/usuarios/usuarios.component.scss
// module chunks = main